import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useI18n } from '../content/i18n';
import './EverywhereSection.css';

gsap.registerPlugin(ScrollTrigger);

const EverywhereSection = () => {
  const { t } = useI18n();
  const sectionRef = useRef(null);
  const subtitleRef = useRef(null);
  const phoneRef = useRef(null);
  
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // 폰 애니메이션
      gsap.fromTo(
        phoneRef.current,
        { 
          opacity: 0,
          scale: 0.8
        },
        {
          opacity: 1,
          scale: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            end: 'top 50%',
            scrub: 1,
          },
        }
      );

      // 설명 텍스트 애니메이션 (PC: 오른쪽에서, 모바일: 아래에서)
      if (subtitleRef.current) {
        const isDesktop = window.innerWidth > 968;
        gsap.fromTo(
          subtitleRef.current,
          { 
            opacity: 0,
            x: isDesktop ? 50 : 0,
            y: isDesktop ? 0 : 30
          },
          {
            opacity: 1,
            x: 0,
            y: 0,
            scrollTrigger: {
              trigger: subtitleRef.current,
              start: 'top 80%',
              end: 'top 50%',
              scrub: 1,
            },
          }
        );
      }
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    // 이미지 fade in/out 전환
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev === 0 ? 1 : 0));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="everywhere-section" ref={sectionRef}>
      <div className="everywhere-content container container--wide">
        <div className="panel-layout">
          {/* 왼쪽: 휴대폰 이미지 */}
          <div className="phone-container" ref={phoneRef}>
            <div className="phone-device-everywhere">
              <div className="phone-notch-everywhere"></div>
              <div className="phone-screen-everywhere">
                <img 
                  src="/resource/lock_screen_1.PNG"
                  alt={t.everywhere.lockAlt1}
                  className={`lockscreen-image ${currentImage === 0 ? 'active' : ''}`}
                />
                <img 
                  src="/resource/lock_screen_2.PNG"
                  alt={t.everywhere.lockAlt2}
                  className={`lockscreen-image ${currentImage === 1 ? 'active' : ''}`}
                />
              </div>
            </div>
          </div>

          {/* 오른쪽: 설명 텍스트 */}
          <div className="description-container" ref={subtitleRef}>
            <p className="description-text">
              백그라운드 재생 기능으로 <span className="highlight-text">언제어디서나</span> 학습이 가능합니다
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EverywhereSection;
